import React, { useMemo } from 'react';
import TransactionItem from './TransactionItem';
import classes from './TransactionsList.module.scss';
import { AutoSizer, List, WindowScroller } from 'react-virtualized';

// NOTE: A bonus reservation moves the bonus from the campaign to the player's
// bonus account, so it is shown as two rows, the same way as on hpui sites.
const splitTransactions = (transactions) =>
  transactions.flatMap((transaction) =>
    transaction.type === 'campaign_bonus_reservation'
      ? [
          { ...transaction, type: 'campaign_bonus_allocation' },
          { ...transaction, type: 'campaign_bonus_reservation' },
        ]
      : [transaction]
  );

const TransactionsList = ({ transactions }) => {
  const rows = useMemo(() => splitTransactions(transactions), [transactions]);

  const renderRow = ({ index, key, style }) => {
    const transaction = rows[index];
    return (
      <div key={key} style={style}>
        <TransactionItem
          type={transaction.type}
          operationType={transaction.operation_type}
          amount={transaction.amount}
          depositAmount={transaction.deposit_amount}
          bonusAmount={transaction.bonus_amount}
          campaignBonusAmount={transaction.campaign_bonus_amount}
          timestamp={transaction.timestamp}
          detail={
            transaction.corr_account
              ? transaction.corr_account.entity.code
              : null
          }
          status={transaction.operation_status}
        />
      </div>
    );
  };

  return (
    <div className={classes.TransactionsList}>
      <WindowScroller>
        {({ height, registerChild, scrollTop }) => (
          <AutoSizer disableHeight>
            {({ width }) => (
              <div ref={registerChild}>
                <List
                  autoHeight
                  scrollTop={scrollTop}
                  width={width}
                  height={height}
                  rowHeight={54}
                  rowRenderer={renderRow}
                  rowCount={rows.length}
                />
              </div>
            )}
          </AutoSizer>
        )}
      </WindowScroller>
    </div>
  );
};

export default TransactionsList;
